import script from "./BaseTextareaForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseTextareaForm.vue?vue&type=script&lang=ts&setup=true"

import "./BaseTextareaForm.vue?vue&type=style&index=0&id=70114885&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70114885"]])

export default __exports__